import Yup from 'utils/validation/yup-extensions';

/**
 * Form property keys.
 * @type {object}
 */
export const FORM_KEYS = {
	ACKNOWLEDGMENT: 'checkboxStaffAccessAcknowledgment',
};

/**
 * Default Formik form initial value object.
 * @type {object}
 */
export const FORM_INITIAL_VALUES = {
	[FORM_KEYS.ACKNOWLEDGMENT]: false,
};

/**
 * Default Formik form Yup validation schema object.
 * @type {object}
 */
export const FORM_VALIDATION_SCHEMA = {
	[FORM_KEYS.ACKNOWLEDGMENT]: Yup.boolean().oneOf(
		[true],
		'Field is required.'
	),
};
